<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2 relative p-12" style="align-self:stretch">
                            <div class="relative flex-1 h-full">
                                <img src="/logo.png" alt="logo" style="position: absolute;left: 0;display: block;object-fit: contain;top: 0;width: 100%;height: 100%;">
                            </div>
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login to Resoil</h4>
                                    <p>Welcome back, please login to your account.</p>
                                </div>
                                <vs-input
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="User"
                                    v-model="email"
                                    :danger="showError && !email.length"
                                    class="w-full no-icon-border"  @keyup.enter="login"/>

                                <vs-input
                                    type="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Password"
                                    v-model="password"
                                    :danger="showError && !password.length"
                                    class="w-full mt-6 no-icon-border"  @keyup.enter="login"/>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                                        <router-link to="/pages/forgot" >Forgot Password?</router-link>
                                    </div>
                                    <!-- <vs-button type="border">Register</vs-button> -->
                                <div class="flex justify-end mt-5">
                                    <vs-button @click.native="login" :disabled="!email.trim() || !password.trim()">Login</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import {$api, saveAuth, $loading} from '@/assets/helper'

export default {
    data() {
        return {
            email: '',
            password: '',
            checkbox_remember_me: false,
            hasError:false,
            showError:false
        }
    },
    methods:{
        login(){
            this.showError = false
            
            if (!this.email.trim().length || !this.password.trim().length) return this.showError = true

            $loading()

            $api.post('/auth/local',{
                identifier:this.email,
                password:this.password
            }).then( ({data}) => {
                if (data.jwt){
                    saveAuth(data.jwt, data.user, this.$store)
                    this.$router.push({path:'/'})
                } else {
                    this.showError = true    
                }
            }).catch(err => {
                return this.$vs.notify({
                    title: 'Error!',
                    text: 'Could not login. Please try again.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    position:'bottom-center'
                })
            })
            .finally( () => {
                $loading.close()
            })
        }
    },
    beforeCreate(){
        localStorage.clear()
    }
}
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
